import type { UserRole } from '../stores/appStore';

const TUNTUN_BUILDER_AGENT_ID = 'tuntun-builder';

export const AGENT_LIST_REFRESH_INTERVAL_MS = 10_000;

export function shouldAutoRefreshAgentList({
  connected,
  userRole,
  allowedAgents,
}: {
  connected: boolean;
  userRole: UserRole;
  allowedAgents: readonly string[];
}): boolean {
  return connected && userRole === 'member' && allowedAgents.includes(TUNTUN_BUILDER_AGENT_ID);
}
